import React from "react";
import { Link } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from "@mui/material";
import "./PageHeading.css";

const PageHeading = ({ title, description, descriptionLink, onInfoClick, infoTooltip }) => {

  // console.log('Page Title',title);

  const renderDescription = () => {
    if (!descriptionLink || !description) return description;

    const { text, to } = descriptionLink;
    const index = description.indexOf(text);
    if (index === -1) return description;

    const before = description.slice(0, index);
    const after = description.slice(index + text.length);

    return (
      <>
        {before}
        <Link to={to} style={{ color: '#56BCF4', textDecoration: 'underline' }}>{text}</Link>
        {after}
      </>
    );
  };

  return (
    <div className="page-heading-container">
      {
        title === 'Text Video AI.' || title === 'Comic Video AI.' ? <h1>{title}</h1> : <h1 className="text-uppercase">{title}</h1>
      }
      <p>{renderDescription()}</p>
      {onInfoClick && (
        <IconButton
          className="page-heading-info-btn"
          onClick={onInfoClick}
          title={infoTooltip || "View sample"}
          size="small"
        >
          <InfoIcon />
        </IconButton>
      )}
    </div>
  );
};

export default PageHeading;
